// Action types
export const FILTER_MODAL_OPENED = 'FILTER_MODAL_OPENED'
export const FILTER_MODAL_CLOSED = 'FILTER_MODAL_CLOSED'
export const RESET_FILTER_MODAL = 'RESET_FILTER_MODAL'

// Action creators
export const openFilterModal = () => ({
  type: FILTER_MODAL_OPENED
})

export const closeFilterModal = () => ({
  type: FILTER_MODAL_CLOSED
})
